var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_91_1945)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M16.5365 1.6H20.5364V19.2H8.53638V17.6H18.9364V7.2H2.13638V13.6H6.93638V19.2H5.62248L0.536377 14.4825V1.6H4.53656V0H6.13656V1.6H9.73638V0H11.3364V1.6H14.9365V0H16.5365V1.6ZM4.53656 3.2V4.8H6.13656V3.2H9.73638V4.8H11.3364V3.2H14.9365V4.8H16.5365V3.2H18.9364V5.6H2.13638V3.2H4.53656Z"
          }
        }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M9.33638 8.8H11.7364V11.2H9.33638V8.8Z" } }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M6.93621 8.8H4.53621V11.2H6.93621V8.8Z" } }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M9.33638 13.6H11.7364V16H9.33638V13.6Z" } }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M16.5362 8.8H14.1362V11.2H16.5362V8.8Z" } }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M14.1362 13.6H16.5362V16H14.1362V13.6Z" } })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_91_1945" } }, [
          _c("rect", {
            attrs: {
              width: "20",
              height: "20",
              fill: "white",
              transform: "translate(0.536377)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }